import React from 'react';
import styled from 'styled-components';

const Green = styled.span`
  color: #52c41b;
`;

const Red = styled.span`
  color: #ff6767;
`;

function Markup({ garageCostWithVat, fixedCostWithVAT, prefix = '' }) {
  if (!garageCostWithVat && !fixedCostWithVAT) return <span>0%</span>;
  if (!garageCostWithVat || garageCostWithVat < 0) return <Green>+100%</Green>;
  if (!fixedCostWithVAT) return <Red>-100%</Red>;
  const divided = fixedCostWithVAT / garageCostWithVat;
  if (fixedCostWithVAT < garageCostWithVat) {
    return <Red>{prefix} -{((1 - divided) * 100).toFixed(2)}%</Red>;
  } else {
    return <Green>{prefix} +{((divided - 1) * 100).toFixed(2)}%</Green>;
  }
}

export default Markup;